<template>
  <div>
    <label v-if="label || $slots.label" :for="name" class="input-label">
      <slot name="label" :required="required" :attrs-name="name"
        >{{ label }} <span v-if="required" class="required-input">*</span></slot
      >
    </label>
    <p v-if="labelHelp" class="my-1 text-sm text-gray-500">
      {{ labelHelp }}
    </p>
    <div class="relative">
      <textarea
        :id="`id_${name}`"
        v-model="value"
        :name="name"
        :rows="$attrs.rows || 4"
        :cols="$attrs.cols"
        :placeholder="$attrs.placeholder"
        :disabled="disabled"
        class="input-base text-sm"
        :class="{
          'pr-10': displayedError,
          'border-gray-300 element-focus': !displayedError,
          'input-error': displayedError,
          'input-disabled': disabled,
          [classWidth]: true,
        }"
      />
      <div
        v-if="displayedError"
        class="absolute top-0 pt-3 right-0 pr-3 flex items-center pointer-events-none"
      >
        <SolidExclamationCircleIcon class="h-5 w-5 text-red-500" />
      </div>
    </div>
    <p class="mt-1 text-sm flex flex-col-reverse sm:flex sm:flex-row">
      <span
        v-if="displayedError || help"
        :class="{
          'text-gray-500': !displayedError,
          'text-red-600': displayedError,
        }"
      >
        {{ displayedError || help }}
      </span>
      <span
        v-if="defaultText && canAddDefault"
        class="ml-auto link-no-underline shrink-0"
        @click="addDefaultText"
      >
        Ajouter le texte par défaut
      </span>
    </p>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useFieldValidation } from '@/api/useValidation'

export default {
  name: 'TTextarea',
  props: {
    name: {
      type: String,
      default: '',
    },
    validator: {
      type: String,
      default: 'validator',
    },
    label: {
      type: String,
      default: '',
    },
    labelHelp: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Number, String],
      default: '',
    },
    error: {
      type: [String, Array],
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classWidth: {
      type: String,
      default: 'w-full',
    },
    defaultText: {
      type: String,
      default: '',
    },
    canAddDefault: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, context) {
    const value = computed({
      get() {
        return props.modelValue
      },
      set(value) {
        context.emit('update:modelValue', value)
      },
    })
    const addDefaultText = () => {
      if (props.disabled) {
        return
      }
      let newValue = value.value
      if (newValue) {
        newValue += '\n' + props.defaultText
      } else {
        newValue = props.defaultText
      }
      context.emit('update:modelValue', newValue)
    }
    return {
      value,
      ...useFieldValidation(props),
      addDefaultText,
    }
  },
}
</script>
